import { Outlet } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import ExitIntentPopup from "@/components/site/ExitIntentPopup";
import MobileBottomNav from "@/components/site/MobileBottomNav";

export default function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-[#0F172A]">
      <Header />
      <main className="flex-1 pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <ExitIntentPopup />
      <MobileBottomNav />
    </div>
  );
}
